import { Trash2 } from "lucide-react";
import { StatusBadge, statusOf } from "./StatusBadge";
import { BudgetStatus } from "./BudgetStatus";

export const ProjectCard = ({ p, i, onOpen, onDelete, owner, prefix = "project" }) => (
  <div data-testid={`${prefix}-card-${i}`} onClick={onOpen}
    className="group cursor-pointer rounded-xl border border-[#2D333F] bg-[#181B21] p-5 hover:border-[#E67E22] transition-colors fade-up" style={{ animationDelay: `${i * 40}ms` }}>
    <div className="flex items-start justify-between gap-2">
      <div className="min-w-0">
        <p data-testid={`${prefix}-card-title-${i}`} className="font-heading font-semibold text-lg truncate">{p.client || "Sem cliente"} {p.name}</p>
        <div className="mt-1.5"><StatusBadge status={statusOf(p)} testId={`${prefix}-status-${i}`} /></div>
        <div className="mt-1.5"><BudgetStatus at={p.budget_sent_at} outdated={p.budget_outdated} testId={`${prefix}-budget-${i}`} /></div>
      </div>
      {onDelete && (
        <button data-testid={`delete-${prefix}-${i}`} onClick={(e) => { e.stopPropagation(); onDelete(); }}
          className="p-1.5 rounded text-[#6B7280] hover:text-red-400 hover:bg-red-950/50"><Trash2 className="w-4 h-4" /></button>
      )}
    </div>
    <div className="mt-5 flex items-end justify-between">
      <p className="font-mono text-xs text-[#6B7280]">{p.piece_count} peças · {p.piece_types} tipos</p>
      <p className="font-mono text-[10px] text-[#4B5563]">{new Date(p.updated_at).toLocaleDateString("pt-BR")}</p>
    </div>
    {owner && (
      <div data-testid={`${prefix}-owner-${i}`} className="mt-2 text-[11px] text-[#CA7C38] space-y-0.5 min-w-0">
        <p className="truncate font-semibold">{p.owner_name || "Usuário"}</p>
        <p className="truncate">{p.owner_email}</p>
        {p.owner_phone && <p className="font-mono">{p.owner_phone}</p>}
      </div>
    )}
  </div>
);
